module.exports = __webpack_public_path__ + "static/IMG_6328.4ed5cc94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/IMG_6328.jpg
// module id = 543
// module chunks = 184314132425989